import { BiBorderAll, BiBuilding, BiBuildings, BiDoughnutChart, BiGroup, BiLocationPlus, BiNetworkChart, BiUser, FaTelegram, HiOutlineAdjustments, HiOutlineClipboardList, MdCampaign } from "react-icons/all";

export const MenuConstants = [
  {
    item: [
      {
        id: "dashboard",
        name: "Dashboard",
        path: "/dashboard",
        icon: <BiBorderAll />,
      },
      {
        id: "attendance",
        name: "Attendance",
        path: "/attendance",
        icon: <BiBuilding />,
      },

      {
        id: "leave-requests",
        name: "Leave Request",
        path: "/leave-request",
        icon: <HiOutlineClipboardList />,
      },
      {
        id: "announcements",
        name: "Announcement",
        path: "/announcement",
        icon: <MdCampaign />,
      },
    ],
  },
  {
    name: "report",
    item: [
      {
        id: "attendance-report",
        name: "Attendance",
        path: "/attendance-report",
        icon: <BiBuilding />,
      },
      {
        id: "leave-request-report",
        name: "Leave Request",
        path: "/leave-request-report",
        icon: <HiOutlineClipboardList />,
      },
    ],
  },
  {
    name: "setting",
    item: [
      {
        id: "employees",
        name: "Employee",
        path: "/employee",
        icon: <BiUser />,
      },
      {
        id: "positions",
        name: "Position",
        path: "/position",
        icon: <BiNetworkChart />,
      },
      {
        id: "departments",
        name: "Department",
        path: "/department",
        icon: <BiBuildings />,
      },
      {
        id: "working-locations",
        name: "Working Location",
        path: "/working-location",
        icon: <BiLocationPlus />,
      },
      {
        id: "work-shifts",
        name: "Work Shift",
        path: "/work-shift",
        icon: <BiDoughnutChart />,
      },
      {
        id: "telegram-notification",
        name: "Telegram Notification",
        path: "/telegram-notification",
        icon: <FaTelegram />,
      },
      {
        id: "system-roles",
        name: "System Roles",
        path: "/system-role",
        icon: <HiOutlineAdjustments />,
      },
      {
        id: "users",
        name: "User",
        path: "/user",
        icon: <BiGroup />,
      },
    ],
  },
];
